import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BuildType } from 'mbs-ui-shared@models';
import {
  BackupHistoryDay,
  BackupHistoryDaySessions,
  BackupHistoryFile,
  BackupHistoryRemote,
  RemoteBackupHistoryParams
} from 'mbs-ui-shared@models/backupHistory';
import { prepareParamsByPayload } from 'mbs-ui-shared@utils/query-params-builder';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackupHistoryService {
  private baseHref = '/api/history';
  constructor(private http: HttpClient) {}

  get(payload?: RemoteBackupHistoryParams): Observable<BackupHistoryRemote> {
    return this.http.get<BackupHistoryRemote>(`${this.baseHref}/plan-sessions-month`, { params: prepareParamsByPayload(payload) });
  }

  getCSV(queryParams?: RemoteBackupHistoryParams): Observable<Blob> {
    const params = cloneDeep(queryParams);

    params.offset && delete params.offset;
    params.limit && delete params.limit;
    params.orderBy && delete params.orderBy;

    return this.http.get(`${this.baseHref}/plan-sessions-month/export`, { params: prepareParamsByPayload(params), responseType: 'blob' });
  }

  getSessionsByDay(hid: string, planid: string, date: BackupHistoryDay): Observable<BackupHistoryDaySessions> {
    return this.http.get<BackupHistoryDaySessions>(`${this.baseHref}/hid/${hid}/plan/${planid}/plan-session-day`, {
      params: { ...date, prev: true, next: true }
    });
  }

  getFilesByDay(
    hid: string,
    planid: string,
    utcStart: string,
    utcEnd: string,
    buildType: BuildType,
    buildVersion: string,
    offset: number
  ): Observable<BackupHistoryFile[]> {
    return this.http.get<BackupHistoryFile[]>(`${this.baseHref}/hid/${hid}/plan/${planid}/files`, {
      params: { utcStart, utcEnd, buildType, buildVersion, offset }
    });
  }

  getFilesByDayCSV(
    hid: string,
    planid: string,
    utcStart: string,
    utcEnd: string,
    buildType: BuildType,
    buildVersion: string
  ): Observable<Blob> {
    return this.http.get(`${this.baseHref}/hid/${hid}/plan/${planid}/files/export`, {
      params: { utcStart, utcEnd, buildType, buildVersion },
      responseType: 'blob'
    });
  }
}
